class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  /* Overlay/backdrop must bind here — constructor runs before children exist on some browsers */
  connectedCallback() {
    if (this._cartDrawerUiBound) return;
    this._cartDrawerUiBound = true;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', (event) => {
      if (this.classList.contains('active') && !event.target.closest('.drawer__inner')) {
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    if (window.Alpine?.store('overlay')?.open) {
      window.Alpine.store('overlay').hide();
    }

    const megaMenu = document.querySelector('mega-menu-drawer');
    if (megaMenu?.querySelector('#MegaMenuDrawer')?.open) {
      megaMenu.close();
    }

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) cartNotification.close();

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    if (this._openActiveTimeout != null) {
      clearTimeout(this._openActiveTimeout);
      this._openActiveTimeout = null;
    }
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    this._openActiveTimeout = setTimeout(() => {
      this._openActiveTimeout = null;
      this.classList.add('animate', 'active');
    }, 0);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (this._openActiveTimeout != null) {
      clearTimeout(this._openActiveTimeout);
      this._openActiveTimeout = null;
    }
    this.classList.remove('active', 'animate');
    const returnFocus = this.activeElement;
    /* Tear down trap without focusing synchronously — refocus during the header
       cart control’s own click can re-fire activation (X inside drawer is fine). */
    removeTrapFocus(null);
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
    document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'false');

    requestAnimationFrame(() => {
      if (returnFocus) {
        if (typeof returnFocus.focus === 'function') {
          try {
            returnFocus.focus({ preventScroll: true });
          } catch {
            returnFocus.focus();
          }
        }
      }
      void this.offsetWidth;
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
